import { render, staticRenderFns } from "./TeamStandingsSection.vue?vue&type=template&id=2c75bad5&scoped=true&"
import script from "./TeamStandingsSection.vue?vue&type=script&lang=js&"
export * from "./TeamStandingsSection.vue?vue&type=script&lang=js&"
import style0 from "./TeamStandingsSection.vue?vue&type=style&index=0&id=2c75bad5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c75bad5",
  null
  
)

export default component.exports